module.exports = __webpack_public_path__ + "static/Estadisticas-4784138fe7a27d8f5d4d53743a23cca1.gif";